import Image from '@components/Image';
import { useTranslation } from 'react-i18next';

import img from './img.png';
import styles from './styles.module.scss';

function PointHeader() {
    const { t } = useTranslation('point');
    return (
        <aside className={styles.container}>
            <div className={styles.card}>
                <Image src={img} alt={t('card.imageAlt')}
                    width={192}
                    height={78} />
            </div>
        </aside>
    );
}

export default PointHeader;
